import { createRouter, createWebHistory } from 'vue-router';
import { Loading } from 'quasar';
import { api } from 'boot/axios';
import ls from 'localstorage-slim';
import store from '../store';
import routes from './routes';
import AuthRoutes from '@/pages/auth/routes';

const unloggedRoutes = [
    ...AuthRoutes[0].children.map((route) => route.name),
    '404',
];

const router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,
    history: createWebHistory(),
});

router.beforeEach(async (to, from, next) => {  // eslint-disable-line
    Loading.show({ message: 'Loading page...' });
    if (!unloggedRoutes.includes(to.name)) {
        let userData = ls.get('userData', { decrypt: true }) ?? {};
        let { hasAccess } = userData;
        if (hasAccess === undefined) {
            const response = await api.get('/api/flag/new_ui');
            if (response.status === 200) {
                hasAccess = response.data.is_active;
            } else {
                const switchResponse = await api.get('/api/switch/new_login');
                if (switchResponse.status === 200 && switchResponse.data.is_active) {
                    next({ name: 'login', params: { next: to.path } });
                } else {
                    window.location = `/accounts/login?next=${to.path}`;
                }
                return next(false);
            }
        }

        if (!hasAccess) {
            window.location = '/dashboard/';
            return next(false);
        }

        if (!userData.company) {
            const response = await api.get('/api/user');
            userData = Object.freeze({ ...response.data, hasAccess });
            ls.set('userData', userData, { ttl: 300, encrypt: true });
        }
        store.commit('updateUserData', userData);
    }
    next();
});

router.beforeResolve(() => {
    Loading.hide();
});

export default router;
